// eslint-disable-next-line no-shadow
enum ProgressStatus {
    INIT = 'INIT',
    ONGOING = 'ONGOING',
    PAUSED = 'PAUSED',
    WARNING = 'WARNING',
    ENDED = 'ENDED',
}
export default ProgressStatus;
